import React from 'react';
import ReactDOM from 'react-dom';
import './erate.css';
import {MainMap} from './Map';
import 'react-sliding-side-panel/lib/index.css';
import {SuccessPage} from './Success'

if(document.getElementById('erate-root')){
  ReactDOM.render(
    <React.StrictMode>
      <MainMap />
    </React.StrictMode>,
    document.getElementById('erate-root')
  );
}

if(document.getElementById('success-root')){
    ReactDOM.render(
    <React.StrictMode>
      <SuccessPage />
    </React.StrictMode>,
    document.getElementById('success-root')
  );
  }